// custom-reuse.strategy.ts
import {
  RouteReuseStrategy,
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
} from '@angular/router';
import { getPath, PathUnit } from '../consts/path.const';

export class CustomReuseStrategy implements RouteReuseStrategy {
  // used to store cached routes
  private cachedRoutes = new Map<string, DetachedRouteHandle>();

  // check if the route should be detached and stored
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const shouldCache = route.routeConfig?.path === getPath(PathUnit.AskBot); // only cache AskBot route
    
    return shouldCache;
  }

  // store the detached route handle
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (handle) {
      const key = this.getRouteKey(route);
      this.cachedRoutes.set(key, handle);
    }
  }

  // check if the route should be reattached from cache
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this.getRouteKey(route);
    return !!this.cachedRoutes.has(key);
  }

  // get the cached route handle
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = this.getRouteKey(route);
    return this.cachedRoutes.get(key) || null;
  }

  // check if the route should be reused (compared to the previous route)
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    // By default, only reuse when the route is exactly the same (e.g., different parameters are considered different routes)
    return future.routeConfig === curr.routeConfig;
  }

  // generate a unique key to identify the route (usually the route path concatenated with parameters)
  private getRouteKey(route: ActivatedRouteSnapshot): string {
    // You can customize the key as needed, such as using only the path or including parameters
    return route.routeConfig ? route.routeConfig.path || '' : '';
  }
}
